/** Parse tier-limit 403 responses from the API. */
export function parseTierLimitError(error) {
  const data = error?.response?.data;
  if (error?.response?.status !== 403 || !data?.error_code) return null;
  if (!String(data.error_code).startsWith('TIER_LIMIT_')) return null;
  return {
    detail: typeof data.detail === 'string' ? data.detail : data.detail?.detail || 'Plan limit reached',
    error_code: data.error_code,
    current_tier: data.current_tier,
    upgrade_to: data.upgrade_to,
  };
}

export const TIER_LIMIT_MESSAGES = {
  TIER_LIMIT_PROPERTIES: 'property limit',
  TIER_LIMIT_AI: 'AI features',
  TIER_LIMIT_NOTIFICATIONS: 'email notifications',
  TIER_LIMIT_BULK_IMPORT: 'bulk import',
  TIER_LIMIT_API_ACCESS: 'API access',
};

let tierErrorHandler = null;

export function registerTierErrorHandler(handler) {
  tierErrorHandler = handler;
}

export function notifyTierLimitError(error) {
  const parsed = parseTierLimitError(error);
  if (parsed && tierErrorHandler) {
    tierErrorHandler(parsed);
  }
  return parsed;
}
